import { useState } from "react";
import styles from "./HoverToolTip.module.css";
import { useEffect } from "react";
import { useRef } from "react";
const HoverToolTip = ({ children, showToolTip, content, variant, trigger }) => {
  const [show, setShow] = useState(false);
  const node = useRef();
  useEffect(() => {
    let handler = (e) => {
      if (!node?.current?.contains(e.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });
  const onMouseEnter = () => {
    if (trigger === "hover") {
      setShow(true);
    }
  };
  const onMouseLeave = () => {
    if (trigger === "hover") {
      setShow(false);
    }
  };

  const onClick = () => {
    if (trigger === "click" && show === false) {
      setShow(true);
    }
  };
  if (!showToolTip) {
    return <>{children}</>;
  }
  return (
    <div
      className={styles.tooltip}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      ref={node}
    >
      {children}
      <div
        className={`${styles.tooltiptext} ${styles[variant]} ${
          show ? styles.active : ""
        } shadow`}
      >
        {content}
      </div>
    </div>
  );
};

export default HoverToolTip;
